module.exports = __webpack_public_path__ + "18ca658b76574b429f1340d2a932820a.MP3";